// Define an enum with string literal values
enum TeamMemberPermissionEnum {
  NoAccess = "no_access",
  Basic = "basic",
  Low = "low",
  Medium = "medium",
  High = "high",
}

// Create a constant array to define the scheduleTypeType
const TeamMemberPermission: { value: string; label: string }[] = [
  { value: TeamMemberPermissionEnum.NoAccess, label: "لا يوجد صلاحية" },
  { value: TeamMemberPermissionEnum.Basic, label: "أساسي " },
  { value: TeamMemberPermissionEnum.Medium, label: "متوسط " },
  { value: TeamMemberPermissionEnum.Low, label: "منخفض " },
  { value: TeamMemberPermissionEnum.High, label: "مرتفع " },
];

const localizedTeamMemberPermission: {
  value: string;
  label: { ar: string; en: string };
}[] = [
  {
    value: TeamMemberPermissionEnum.NoAccess,
    label: { ar: "لا يوجد صلاحية", en: "No Access" },
  },
  {
    value: TeamMemberPermissionEnum.Basic,
    label: { ar: "أساسي", en: "Basic" },
  },
  {
    value: TeamMemberPermissionEnum.Medium,
    label: { ar: "متوسط", en: "Medium" },
  },
  { value: TeamMemberPermissionEnum.Low, label: { ar: "منخفض", en: "Low" } },
  { value: TeamMemberPermissionEnum.High, label: { ar: "مرتفع", en: "High" } },
];

export {
  TeamMemberPermissionEnum,
  TeamMemberPermission,
  localizedTeamMemberPermission,
};

export const getFormatedTeamMemberPermission = (
  value: string,
  currentLang: "ar" | "en" = "ar"
) => {
  const permissions = [
    {
      key: "no_access",
      ar: "لا يوجد صلاحية",
      en: "No Access",
    },
    {
      key: "basic",
      ar: "أساسي",
      en: "Basic",
    },
    {
      key: "low",
      ar: "منخفض",
      en: "Low",
    },
    {
      key: "medium",
      ar: "متوسط",
      en: "Medium",
    },
    {
      key: "high",
      ar: "مرتفع",
      en: "High",
    },
  ] as const;
  const permission = permissions.find((permission) => permission.key === value);
  if (!permission) {
    return "لا يوجد صلاحية";
  }
  return permission[currentLang];
};
